
export default {
  name: 'PagesAboutExtentionsUsersSteps',
  data() {
    return {
      steps: [
        {
          step: 1,
          title: 'Настройте свою среду',
          description:
            'Зарегистрируйтесь и заполните ваш профиль. Можно добавить контакты, а также ссылки на свои социальные сети.',
        },
        {
          step: 2,
          title: 'Подпишитесь на тематические журналы',
          description:
            'Функционал позволяет контролировать изменения в важных для вас темах.',
        },
        {
          step: 3,
          title: 'Подпишитесь на независимых авторов',
          description:
            'Благодаря им даже самые сложные вопросы получают максимально понятные ответы.',
        },
        {
          step: 4,
          title: 'Включите отслеживание изменений в компаниях',
          description:
            'Это возможность быть осведомлённым о том, что происходит в компании-поставщике услуг.',
        },
        {
          step: 5,
          title: 'Всё! Вы настроили свою ленту',
          description:
            'Теперь осталось заходить регулярно, и тогда вы не пропустите важные обновления.',
        },
      ],
    }
  },
}
